(function () {

// model validation directives
angular.module('components.validation', [])
    // Use this when you want the model to be updated even when the value is invalid.
    .directive('minLength', [function () {
        return {
            require: '?ngModel',
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var minlength = parseInt(attr.minLength),
                    validator = function (value) {
                        var isValid = !isEmpty(value) && value.length >= minlength;
                        ctrl.$setValidity('minlength', isValid);
                        return value;
                    };

                ctrl.$formatters.push(validator);
                ctrl.$parsers.push(validator);

                attr.$observe('minLength', function () {
                    validator(ctrl.$viewValue);
                });
            }
        };
    }])

    // Use this when you want the model to be updated even when the value is invalid.
    .directive('maxLength', [function () {
        return {
            require: '?ngModel',
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var maxlength = parseInt(attr.maxLength),
                    validator = function (value) {
                        var isValid = isEmpty(value) || value.length < maxlength;
                        ctrl.$setValidity('maxlength', isValid);
                        return value;
                    };

                ctrl.$formatters.push(validator);
                ctrl.$parsers.push(validator);

                attr.$observe('maxLength', function () {
                    validator(ctrl.$viewValue);
                });
            }
        };
    }])

    .directive('invalidChars', [function () {
        return {
            require: '?ngModel',
            link: function (scope, elm, attr, ctrl) {
                if (!ctrl) return;

                var regex = isEmpty(attr.invalidChars) ? /[<>{}\\]/g : new RegExp("[" + attr.invalidChars + "]", "g"),
                    validator = function (value) {
                        if (isEmpty(value)) {
                            return value;
                        }
                        value = value.replace(regex, "");
                        if (ctrl.$viewValue !== value) {
                            ctrl.$viewValue = value;
                            ctrl.$render(); //update the DOM
                        }
                        return value;   //value to bind to the model
                    };

                ctrl.$formatters.push(validator);
                ctrl.$parsers.push(validator);

                attr.$observe('invalidChars', function () {
                    validator(ctrl.$viewValue);
                });
            }
        };
    }]);

    function isEmpty(value) {
        return angular.isUndefined(value) || value === '' || value === null || value !== value;
    }

}());